// Module
var code = `<div class="account-select">
  <selectize options="\$ctrl.options"
             ng-model="\$ctrl.innerModel"
             config="\$ctrl.config"
             class="nx-selectize"
             ng-required="\$ctrl.\$attrs.required"
             ng-disabled="\$ctrl.ngDisabled"
  >
  </selectize>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/account-select/account-select.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;